export default {
    "login": {
        "text_modal_title": "客户服务平台",
        "phd_account": "电邮或电话",
        "phd_password": "密码",
        "text_btn_login": "登录",
        "link_forget_pwd": "忘记密码",
        "login": "登入成功",
        "account_not_filled": "请填写电邮或电话",
        "password_not_filled": "请填写密码",
        "account_password_error": "帐户或密码错误",
        "text_btn_reg": "注册"
    },
    "reg": {
        "text_ipt_email": "电邮",
        "text_ipt_email_vcode": "电邮验证码",
        "text_btn_vcode": "获取",
        "text_ipt_phone": "电话",
        "text_ipt_pwd": "密码",
        "text_btn_login": "登录",
        "text_ipt_pwd_confirm": "确认密码",
        "text_btn_reg": "注册",
        "text_reg_succ": "注册成功",
        "email_not_filled": "请填写电邮",
        "email_vcode_not_filled": "请填写电邮验证码",
        "phone_not_filled": "请填写电话",
        "password_not_filled": "请填写密码",
        "password_confirm_not_filled": "请填写确认密码",
        "password_not_same": "两次密码不一致",
        "reg_failed": "注册失败"
    },
    "forget_pwd": {
        "text_forgetpwd_modal_title": "忘记密码",
        "text_ipt_email": "电邮",
        "btn_forgetpwd": "发送重置密码电邮",
        "text_btn_login": "登录",
        "noti_sent": "已发送，请留意电邮",
        "email_not_filled": "请填写电邮",
        "error_sent_failed": "发送失败"
    },
    "reset_pwd": {
        "text_ipt_pwd": "密码",
        "text_ipt_pwd_confirm": "确认密码",
        "password_not_filled": "请填写密码",
        "password_confirm_not_filled": "请填写确认密码",
        "password_not_same": "两次密码不一致",
        "text_resetpwd_modal_title": "重置密码",
        "btn_resetpwd": "确认密码",
        "noti_reset_succ": "已更改密码",
        "error_reset_failed": "更改失败"
    },
    "sidebar": {
        "text_modal_title": "客户服务平台",
        "account": "帐户",
        "company": "公司",
        "homepage": "自助平台主页",
        "service_account": "服务账户",
        "account_brief": "账户总览",
        "account_enquiry": "账户咨询",
        "account_service": "账户服务",
        "e_card": "电子客户卡",
        "file_inform": "文件通知",
        "bill_and_renew": "账单与续约",
        "delegate_permission": "委派存取权",
        "personal_account": "个人账户",
        "wallet": "钱包",
        "request_a_service": "申请服务",
        "manual": "说明",
        "suggestion_and_enquiry": "用户意见/查询",
        "logout": "登出成功",
        "tab_user_management": "用户管理",
        "tab_service_management": "服务管理",
        "tab_service_management_services": '套餐管理',
        "tab_service_management_credits": '点数管理',
        "tab_service_management_hk": "香港境內公司",
        "tab_service_management_hk_l": "有限公司",
        "tab_service_management_hk_Ul": "无限公司",
        "tab_service_management_os": "香港境外公司",
        "tab_service_management_os_bvi": "BVI",
        "tab_service_management_os_cayman": "开曼",
        "tab_service_management_os_seychelles": "塞舌尔",
        "tab_service_management_so": "服务式办公室",
        "tab_service_management_vo": "虛擬辦公室",
        "tab_service_management_cs": "公司秘书服务",
        "tab_service_management_as": "会计服务",
        "tab_service_management_as_proxy": "会计报税",
        "tab_service_management_as_tax": "代理会计",
        "tab_service_management_val_added": "加值服务",
        "tab_service_management_val_added_be": "企业电邮",
        "tab_service_management_val_added_bnc": "卡片印刷",
        "tab_service_management_val_added_csl": "定制印章",
        "tab_service_management_val_added_tr": "注册商标",
        "tab_service_management_val_added_bar": "银行户口",
        "tab_individual": "个人帐户",
        "tab_apply_form": "服务管理",
        "tab_apply_form_hk": "香港境內公司",
        "tab_apply_form_hk_l": "有限公司",
        "tab_apply_form_hk_ul": "无限公司",
        "tab_apply_form_os": "香港境外公司",
        "tab_apply_form_os_bvi": "BVI",
        "tab_apply_form_os_cayman": "开曼",
        "tab_apply_form_os_seychelles": "塞舌尔",
        "tab_apply_form_so": "服务式办公室",
        "tab_apply_form_vo": "虛擬辦公室",
        "tab_apply_form_cs": "公司秘书服务(即将推出)",
        "tab_apply_form_as": "会计服务",
        "tab_apply_form_as_proxy": "会计报税",
        "tab_apply_form_as_tax": "代理会计",
        // "tab_apply_form_as": "会计服务(即将推出)",
        // "tab_apply_form_as_proxy": "会计报税(即将推出)",
        // "tab_apply_form_as_tax": "代理会计(即将推出)",
        "tab_apply_form_val_added": "加值服务",
        "tab_apply_form_val_added_be": "企业电邮",
        "tab_apply_form_val_added_bnc": "卡片印刷",
        "tab_apply_form_val_added_csl": "定制印章",
        "tab_apply_form_val_added_tr": "注册商标",
        "tab_apply_form_val_added_bar": "银行户口",
        "text_tips_i18n": '请转换语言后刷新界面'
    },
    "individual": {
        "col_label_name": "公司名称",
        "col_label_name_cn": "公司中文名称",
        "col_label_applier": "申请人",
        "col_label_package": "套餐/服务",
        "col_label_updatedat": "更新时间",
        "col_label_status": "状态",
        "col_label_operation": "操作",
        "noti_sent_recp_succ": "发出成功",
        "error_sent_recp_failed": "发出失败",
        "noti_sent_inv_succ": "获取成功",
        "error_sent_inv_failed": "获取失败",
        "label_detail": "详情",
        "label_invoice": "发票",
        "label_receipt": "收据",
        "label_hello": "你好",
        "label_current_credit": "目前Credit为：",
        "label_value_added": "加值",
        "label_added_record": "申请记录",
        "label_send_recp": "发出收据",
        "label_recp_annual": "报表年度",
        "label_recp_annual_start": "发出日期",
        "label_recp_annual_end": "到期日期",
        "label_confirm": "确定",
        "label_cancel": "取消"
    },
    "upload_button": {
        "label_upload": "上传文件",
        "noti_uploaded_succ": "上传成功",
        "error_uploaded_failed": "上传失败"
    },
    "preview_router_form": {
        "form_title_1": "联系人资料",
        "form_title_2": "所选择之服务计划",
        "form_title_3": "成立/购买现成有限公司资料",
        "form_title_4": "发行股本",
        "form_title_5": "请选择董事及创办成员成员数目",
        "form_title_6": "增值服务",
        "label_form_name": "*姓名：",
        "label_form_title": "*称谓：",
        "label_form_phone": "*电话：",
        "label_form_email": "*电邮：",
        "label_form_address": "地址：",
        "label_form_contact_way": "希望我们以什么方式联系：",
        "label_form_contact_slot": "希望我们什么时间联系您：",
        "label_form_com_en_name": "公司英文名称：",
        "label_form_com_cn_name": "公司中文名称：",
        "label_form_com_addr": "*公司通讯地址(如套餐包含虚拟地址服务，则该项默认为虚拟地址)：",
        "label_form_com_addr_use_default": "*选用汇联地址作为注册地址：",
        "label_form_com_addr_reg": "*注册地址：",
        "label_form_preset_shares": "*预设注册资本为1港币，分为1股，每股面值1港币：",
        "label_form_preset_shares_en": "*预设注册资本为1美元，分为1股，每股面值1美元：",
        "label_form_is_num": "发行股数：",
        "label_form_val": "每股面值（港币）：",
        "label_form_val_en": "每股面值（美元）：",
        "label_form_val_total": "总面值（港币）：",
        "label_form_val_total_en": "总面值（美元）：",
        "label_form_bus_nature": "*业务性质：",
        "label_form_bus_region": "*业务地区：",
        "label_form_board_num": "请选择董事及创办成员成员数目：",
        "label_form_value_added": "增值服务：",
        "label_form_uploaded_file": "上传文件：",
        "label_form_board_no_before": "*第",
        "label_form_board_no_after": "名股东：",
        "label_form_board_identity": "*身份：",
        "label_form_board_holding": "股份数目：",
        "label_form_board_sh_en_name": "名股东/董事英文名称：",
        "label_form_board_sh_cn_name": "名股东/董事中文名称：",
        "label_form_board_sh_phone": "*电话：",
        "label_form_board_sh_email": "*电邮：",
        "label_form_board_sh_address_before": "*住址 （第",
        "label_form_board_sh_address_after": "名股东/董事）：",
        "label_form_board_sh_id_before": "*身份证/护照 （第",
        "label_form_board_sh_id_after": "名股东/董事）：",
        "label_form_board_sh_ic_before": "*签发国家 （第",
        "label_form_board_ic_after": "名股东/董事）：",
        "label_form_board_com_reg_addr": "*公司注册住址 （如身份是公司）：",
        "label_form_board_com_reg_num": "*公司注册号码 （如身份是公司）：",
        "label_form_board_com_reg_bus_num": "*商业登记证号码 （如身份是公司）：",
        "label_form_board_com_reg_c": "*注册国家 （如身份是公司）：",
        "label_form_board_com_fund_source": "详细资金来源（如身份是公司）",
        "label_form_board_com_fund_source_before": "详细资金来源 （第",
        "label_form_board_com_fund_source_after": "名股东/董事）",
        "noti_form_edit_succ": "更改成功",
        "error_form_edit_failed": "更改失败",
        "label_form_edit": "编辑",
        "label_form_confirm": "完成",
        "label_form_cancel": "取消",
        "label_form_title_male": "先生",
        "label_form_title_female": "小姐",
        "label_form_contact_way_wts": "whatsapp",
        "label_form_contact_way_phone": "电话",
        "label_form_contact_way_email": "电邮",
        "label_form_contact_way_wechat": "微信",
        "label_form_contact_way_wechat_no": "你的微信",
        "label_form_contact_slot_912": "9am -12pm",
        "label_form_contact_slot_23": "2-3pm",
        "label_form_contact_slot_35": "3-5:30pm",
        "label_form_preset_shares_yes": "是",
        "label_form_preset_shares_no": "否",
        "label_form_com_addr_use_default_yes": "是",
        "label_form_com_addr_use_default_no": "否",
        "label_form_board_num_new": "新增",
        "label_form_value_added_be": "企业电邮（另需报价）",
        "label_form_value_added_cp": "名片印刷",
        "label_form_value_added_cp_1": "名片印刷 100 张",
        "label_form_value_added_cp_2": "名片印刷 200 张",
        "label_form_value_added_cs": "定制印章",
        "label_form_value_added_cs_1": "签字章",
        "label_form_value_added_cs_2": "圆章",
        "label_form_value_added_ba": "申请银行账户（另需报价）",
        "label_form_value_added_tm": "注册商标（另需报价）",
        "label_form_value_added_cse": "公司秘书",
        "label_form_previous": "上一步",
        "label_form_next": "下一步",
        "label_form_preview": "预览",
        "label_form_submit": "递交",
        "error_form_fill_form": "请填写完资料",
        "noti_form_submit_succ": "提交成功",
        "error_form_submit_failed": "提交失败",
        "label_form_board_indentity_personal": "个人",
        "label_form_board_indentity_company": "公司",
        "label_form_board_indentity_director": "董事",
        "label_form_board_indentity_shareholder": "股东",
        "col_label_name": "公司名称",
        "col_label_name_cn": "公司中文名称",
        "col_label_applier": "申请人",
        "col_label_package": "套餐/服务",
        "col_label_amount": "金额",
        "col_label_updatedat": "更新时间",
        "col_label_status": "状态",
        "col_label_operation": "操作",
        "label_export_as": "导出为",
        "label_export_as_csv": "CSV",
        "label_export_as_pdf": "PDF",
        "noti_msg_delete": "一旦删除将无法恢复，确定吗？",
        "label_delete": "删除",
        "label_export_file_format": "账户总览.pdf",
        "label_form_table_title": "账户总览",
        "label_form_pig_singular": "个项目",
        "label_form_pig_plural": "个项目",
        "label_form_pig_message": "选中",
        "label_form_pig_rows_per_page": "每页：",
        "label_form_pig_select_all": "全部",
        "col_label_user_name": "用户名",
        "col_label_user_phone": "电话",
        "col_label_user_email": "电邮",
        "col_label_user_title": "称谓",
        "noti_delete_succ": "删除成功",
        "error_delete_failed": "删除失败",
        "noti_update_succ": "修改成功",
        "error_update_failed": "修改失败",
        "label_profile_title": "修改个人信息",
        "col_label_user_enquiry_type": "咨询类型",
        "noti_reply_succ": "已回复",
        "error_reply_failed": "回复失败",
        "label_reply_phd": "请填写回复电邮",
        "label_reply": "回复",
        "label_search_component_type": "类型",
        "noti_create_succ": "新增成功",
        "error_create_failed": "新增失败",
        "label_create": "创建",
        "label_cancel": "取消",
        "label_no_data_show": "暂时没有数据显示",
        "col_package_name": "套餐",
        "col_package_price": "价格",
        "col_package_content_tc": "繁中内容",
        "col_package_content_cn": "简中内容",
        "col_package_content_en": "英文内容",
        "col_package_discount": "折扣",
        "col_package_discount_start": "折扣开始时间",
        "col_package_discount_end": "折扣结束时间",
        "form_title_vo_1": "填写公司资料",
        "form_title_vo_2": "虚拟办公室联系人",
        "form_title_vo_3": "增值服务",
        "form_title_vo_4": "完成结束",
        "form_title_vo_col_identity": "选择申请身份",
        "form_title_vo_col_identity_com": "香港公司/无限公司/其他",
        "form_title_vo_col_identity_ind": "个人",
        "form_title_vo_col_identity_org": "团体组织",
        "form_title_vo_col_bus_reg_license": "商业登记证",
        "form_title_vo_col_bus_reg_license_yes": "有",
        "form_title_vo_col_bus_reg_license_no": "无",
        "form_title_vo_col_reg_date": "注册日期",
        "form_title_vo_col_bus_reg_num": "商业登记号码",
        "form_title_vo_col_need_upload_file": "需上载文件（可于‘个人账户->申请记录->上传文件’处补交文件）",
        "form_title_vo_col_file_bug_reg_copy": "1、商业登记证副本（如有公司登记证书副本）",
        "form_title_vo_col_main_contact": "主要联系人（至少一名，可多名）",
        "form_title_vo_col_main_contact_identity": "联系人身份",
        "form_title_vo_col_main_contact_identity_director": "董事",
        "form_title_vo_col_main_contact_identity_sh": "股东",
        "form_title_vo_col_main_contact_identity_secretary": "公司秘书",
        "form_title_vo_col_main_contact_identity_staff": "职员",
        "form_title_vo_col_main_contact_identity_agent": "代理人",
        "form_title_vo_col_main_contact_title": "称呼",
        "form_title_vo_col_main_contact_title_mr": "先生",
        "form_title_vo_col_main_contact_title_miss": "小姐",
        "form_title_vo_col_main_contact_title_mrs": "女士",
        "form_title_vo_col_main_contact_name_en": "英文姓名",
        "form_title_vo_col_main_contact_name_cn": "中文姓名",
        "form_title_vo_col_main_contact_phone": "联系电话",
        "form_title_vo_col_main_contact_email": "联系电邮",
        "form_title_vo_col_main_contact_address": "通讯地址",
        "form_title_vo_col_main_contact_birthday": "出生年月日",
        "form_title_vo_col_main_contact_identity_verify": "核实身份",
        "form_title_vo_col_main_contact_identity_verify_gotobank": "1、亲身到分行",
        "form_title_vo_col_main_contact_identity_verify_online": "2、视讯",
        "form_title_vo_col_main_contact_file_hkid_copy": "1、联系人证件",
        "form_title_vo_confirm": "确认并提交申请",
        "form_title_vo_tac_com_1": "1、本人明白必须于12日内或按客户服务员指引尽快交回签署好的文件以完成相关程序，否则引起的罚款或后果本人需要自行承担。本人亦明白如果1个月内我未有提交足以完成申请服务的文件，将被视为放弃服务，我将不会得到退款，继续服务需重新收费。",
        "form_title_vo_tac_com_2": "2、我确定这不是上市公司，我清楚如果虚报将被即时终止服务。",
        "form_title_vo_tac_com_3": "3、我确定以上所填写资料准确无误，并已阅读及同意虚拟办公室服务条款，我同意如果由于上述资料错误而产生任何问题或行政费将由我负责。",
        "form_title_vo_tac_tips": "*提交表格即代表同意上述条款",
        "form_title_vo_col_ind_file_address_copy": "1、地址证明副本",
        "form_vo_col_reg_country": "注册国家",
        "form_vo_col_org_num": "团队组织号码",
        "form_title_vo_col_org_file_org_copy": "1、团队组织证明副本",
        "form_title_vo_tac_ind_1": "1、本人明白必须于12日内或按客户服务员指引尽快交回签署好的文件以完成相关程序，否则引起的罚款或后果本人需要自行承担。本人亦明白如果1个月内我未有提交足以完成申请服务的文件，将被视为放弃服务，我将不会得到退款，继续服务需重新收费。",
        "form_title_vo_tac_ind_2": "2、我确定以上所填写资料准确无误，并已阅读及同意虚拟办公室服务条款，我同意如果由于上述资料错误而产生任何问题或行政费将由我负责。",
        "form_title_vo_tac_org_1": "1、本人明白必须于12日内或按客户服务员指引尽快交回签署好的文件以完成相关程序，否则引起的罚款或后果本人需要自行承担。本人亦明白如果1个月内我未有提交足以完成申请服务的文件，将被视为放弃服务，我将不会得到退款，继续服务需重新收费。",
        "form_title_vo_tac_org_2": "2、我确定以上所填写资料准确无误，并已阅读及同意虚拟办公室服务条款，我同意如果由于上述资料错误而产生任何问题或行政费将由我负责。",
        "form_cs_file_com_reg": "2、公司注册证",
        "form_cs_file_com_policy": "3、公司章程",
        "form_cs_file_director_list": "4、董事名册",
        "form_cs_file_sh_list": "5、股东名册",
        "form_cs_file_main_ctr_list": "6、主要控制人登记册",
        "form_cs_file_nar1_last_year": "上年申报 NAR1 表格",
        "form_cs_file_nar1_updated_last_year": "上年度提交 NAR1 后是否有提交其他变更文件或转股文件（如有都需上传）",
        "form_cs_file_director_sh_id": "1、身份证/护照/通行证副本",
        "form_cs_file_director_address_verify": "2、地址证明",
        "form_title_cs_1": "公司资料",
        "form_title_cs_2": "董事/股东资料",
        "form_title_cs_3": "秘书公司（如非本公司）",
        "form_cs_col_sh_holding": "持股数量",
        "form_cs_col_sc_com": "秘书公司（如非本公司）",
        "form_cs_col_sc_title": "称呼",
        "form_cs_col_sc_name_cn": "中文名称",
        "form_cs_col_sc_name_en": "英文名称",
        "form_cs_col_sc_phone": "联系电话",
        "form_cs_col_sc_email": "联系电邮",
        "form_cs_col_sc_addr": "通讯地址",
        "form_ex_cp_title_1": "联系人资料",
        "form_ex_cp_title_2": "提供名片上资料",
        "form_ex_cp_col_isbilinguish": "选择卡片语言",
        "form_ex_cp_col_isbilinguish_cn": "中文",
        "form_ex_cp_col_isbilinguish_en": "英文",
        "form_ex_cp_col_isbilinguish_other": "其他",
        "form_ex_cp_col_position_cn": "中文职位",
        "form_ex_cp_col_position_en": "英文职位",
        "form_ex_cp_col_addr_cn": "中文联络地址",
        "form_ex_cp_col_addr_en": "英文联络地址",
        "form_ex_cp_col_other": "备注",
        "form_ex_cp_col_c_phone": "联系电话",
        "form_ex_cp_col_c_email": "联系电邮",
        "form_ex_cs_title_1": "印章中英文名称",
        "form_ex_rb_title_1": "填写商标信息",
        "form_ex_rb_tm_reg": "商标注册地",
        "form_ex_rb_tm_holder": "商标拥有人姓名",
        "form_ex_rb_tm_holder_addr": "商标拥有人通讯地址",
        "form_ex_rb_tm_holder_id": "个人身份证件(如商标拥有人为个人则需要上传)",
        "form_ex_rb_tm_holder_bus": "商业登记证件(如商标拥有人为公司则需要上传)",
        "form_ex_rb_tm_holder_reg": "公司注册证明(如商标拥有人为公司则需要上传)",
        "form_ex_rb_tm_holder_dir": "任意一名董事资料(如商标拥有人为公司则需要上传)",
        "form_ex_rb_tm_icon": "拟注册商标之图案",
        "form_ex_rb_tm_type": "拟注册商标之类别",
        "form_ex_rb_tm_desc": "拟注册商标之详细说明",
        "form_credit_total": "点数总额",
        "form_credit_add_to": "为该帐户增值",
        "label_confirm": "确定",
    },
    "payment": {
        "label_pay": "付款",
        "label_val_added": "加值",
        "label_return_indi": "返回个人帐户",
        "label_payment_succ": "成功",
        "label_payment_failed": "失败",
        "label_payment_cancel": "取消"
    },
    "suggestion": {
        "error_sug_not_filled": "请填写完整资料",
        "noti_sug_sent_succ": "发送成功",
        "error_sug_sent_failed": "发送失败",
        "label_sug_enquiry_type": "查询类型",
        "label_sug_name": "姓名",
        "label_sug_email": "电邮",
        "label_sug_phone": "电话",
        "label_sug_msg": "正文",
        "label_sug_send": "送出"
    },
    "wallet": {
        "col_applier": "申请人",
        "col_amount": "银码",
        "col_updated_at": "更新时间",
        "col_status": "状态",
        "error_val_added_failed": "加值失败",
        "label_wallet_current_credit": "Credit加值金额：",
        "label_wallet_other_payments": "其他增值方式（成功付款后请联络管理员）：",
        "value_100": "100HKD",
        "value_200": "200HKD",
        "value_500": "500HKD",
        "value_1000": "1000HKD",
        "value_2000": "2000HKD",
        "value_3000": "3000HKD",
        "btn_val_added": "增值",
        "label_past_record": "过往加值记录"
    },
    "reply_selection": {
        "label_reply_type_hkr": '注册香港公司',
        "label_reply_type_osr": '注册海外公司',
        "label_reply_type_as": '会计服务',
        "label_reply_type_cs": '公司秘书',
        "label_reply_type_so": '服务式办公室',
        "label_reply_type_vo": '虚拟办公室',
        "label_reply_type_va": '增值服务',
    }
}